var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { jurisdictionEntityName } from '@juvare/platform-sdk-react/backend/features/default-classifiers/shared';
export function getPostalCodeByName(value, errors, errorMessage, filter) {
    return __awaiter(this, void 0, void 0, function* () {
        if (value) {
            const result = yield new StorageClient(jurisdictionEntityName).list({
                filter: [{ column: 'name', op: '=', value }, ...(filter ? filter : [])],
                limit: 1,
            });
            if (result.rows.length > 0) {
                return result.rows[0].columns.postalCode;
            }
            else {
                errors.push(errorMessage);
            }
        }
        return undefined;
    });
}
